"use strict";

exports.__esModule = true;
exports.CELL_TYPE = exports.AutocompleteCellType = void 0;
var _autocompleteType = require("./autocompleteType");
exports.AutocompleteCellType = _autocompleteType.AutocompleteCellType;
exports.CELL_TYPE = _autocompleteType.CELL_TYPE;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/autocompleteType/index.js
// module id = 1088
// module chunks = 0